
export const validatePaginationParams = (page, perPage = 10) => {
 
  const validPage = (page === undefined || page === null || page < 1) ? 1 : page;

  const validPerPage = (perPage === undefined || perPage === null || perPage < 1) ? 10 : perPage;

  return { page: validPage, perPage: validPerPage };
};
